module.exports = __webpack_public_path__ + "media/floorPlans/floorPlansBaseChange-5e28f891.png";